import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const isFor = ['Te sientes invisible en tu propia relación.', 'Lloras en silencio para que nadie sepa cuánto te humillas por él.', 'Si hoy te pasara algo, sabes que él no correría por ti — pero tú sí por él.'];
const isNotFor = ["Quieres seguir siendo el 'tapete' de alguien que no te quiere.", 'Disfrutas el drama tóxico y no quieres sanar.'];
export function WhoFor() {
  return <section className="py-16 md:py-24 px-5 bg-[#F2EBE1]" data-id="element-170">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-172">
          <h3 className="font-serif text-2xl md:text-3xl text-[#5C1A2B] mb-6 border-b border-[#5C1A2B]/20 pb-3" data-id="element-173">
            Es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-174">
            {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-175">
                <CheckCircle2Icon className="w-5 h-5 text-[#C86B5E] flex-shrink-0 mt-1" data-id="element-176" />
                <span className="text-base text-[#2D2D2D] font-light leading-relaxed" data-id="element-177">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-178">
          <h3 className="font-serif text-2xl md:text-3xl text-[#8A8A8A] mb-6 border-b border-[#8A8A8A]/20 pb-3" data-id="element-179">
            NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-180">
            {isNotFor.map((item, i) => <li key={i} className="flex items-start gap-3 opacity-70" data-id="element-181">
                <XCircleIcon className="w-5 h-5 text-[#8A8A8A] flex-shrink-0 mt-1" data-id="element-182" />
                <span className="text-base text-[#4A4A4A] font-light leading-relaxed line-through decoration-[#8A8A8A]/40" data-id="element-183">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}